<template>
    <div class="panel-form d-flex flex-column flex-fill h-100">
        <div class="row flex-fill">
            <div class="col">
                <template v-if="loading">
                    <div class="panel-form-data loading">
                        <div class="">
                            <div class="full-size-loader"></div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <template v-if="loadingError" >
                        <div class="alert alert-danger" role="alert">
                            {{ errorMsg }}
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="pageHtml">
                            <div v-html="pageHtml"></div>
                        </template>
                        <template v-else-if="data">
                            <div class="panel-form-data">
                                <div id="formProperties" class="accordion">
                                  <div class="card accordion" v-for="(item, key, idx) in data" :key="`card-info-${idx}`">
                                    <div class="card-header" :id="`heading${key}`" v-if="item.title">
                                        <div class="row no-gutters">
                                            <div
                                                class="col"
                                                data-toggle="collapse"
                                                :data-target="`#collapse${key}`"
                                                :aria-controls="`collapse${key}`"
                                                :aria-expanded="idx==0"
                                            >
                                                {{ item.title ? item.title : '' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        :id="`collapse${key}`"
                                        class="collapse"
                                        :class="{'show': idx==0}"
                                        :aria-labelledby="`heading${key}`"
                                        data-parent="#formProperties">
                                        <div class="card-body" :class="{'px-0': !item.title}">
                                            <!-- <form>
                                              <div class="row" v-for="(propVal, propKey) in item.data">
                                                <label :for="`static${propKey}`" class="col-sm-5 col-form-label">{{ propKey }}</label>
                                                <div class="col-sm-7">
                                                  <input type="text" readonly class="form-control-plaintext" :id="`static${propKey}`" :value="propVal">
                                                </div>
                                              </div>
                                            </form> -->
                                            <table>
                                                <tbody>
                                                    <tr
                                                        v-for="(propVal, propKey) in item.data"
                                                        :key="propKey">
                                                        <td>
                                                            {{ propKey }}
                                                        </td>
                                                        <td>
                                                            <template v-if="isString(propVal)">
                                                                {{ propVal }}
                                                            </template>
                                                            <template v-else>
                                                                <div v-html="renderItemVal(propVal)"></div>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import GlobalMixin from '@/app/shared/mixins/global';
    import {isObject, isString} from '@config/utils';

    export default {
        name: 'FormPropertiesViewer',
        mixins: [
            GlobalMixin
        ],
        components: {

        },
        props: {
            title: {
                type: String,
                default: '',
            },
            url: {
                type: String,
                default: '',
            },
            useProxy: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                loading: true,
                loadingError: false,
                errorMsg: 'Ocorreu um erro',
                data: null,
                pageHtml: null,

            }
        },
        mounted() {
            this.reset();
            this.loadInfo()
            .then(data => {
                if(data){
                    if(data.exception){
                        console.error(data.message);
                        this.loadingError=true;
                    }else{
                        if (typeof data === "string") {
                            this.pageHtml = data;
                        }else {
                            let keys = Object.keys(data);
                            if(keys.length>0){
                                let groups = keys.filter(k => isObject(data[k])
                                    && Object.keys(data[k]).filter(x => ['title', 'data'].includes(x)).length==2);
                                if(groups.length == keys.length){
                                    this.data = data;
                                }else{
                                    this.data = {group: {title: null, data}};
                                }
                            }else{
                                this.loadingError=true;
                            }
                        }
                    }
                }else{
                    this.loadingError=true;
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
        computed: {
            httpUrl() {
                return this.useProxy ? axios.defaults.proxyURL : this.url;
            },
            configHttpAxios() {
                return this.useProxy ? {
                    headers: {
                        'X-Proxy-Url': this.url,
                    }
                } : {};
            },
        },
        methods: {
            isString,
            reset() {
                Object.assign(this.$data, this.$options.data());
            },
            async loadInfo() {
                return await this.$http.get(this.httpUrl, this.configHttpAxios)
                .then( res => {
                    let data = res.data ? (res.data.data ? res.data.data : res.data ) : res;
                    return data;
                })
                .catch( error => {
                    this.showHttpError(error);
                    this.loadingError=true;
                })
                return null;
            },
            renderItemVal(item) {
                if(isObject(item)) {
                    if(item.href) {
                        let label = item.label || item.value;
                        let target = item.target || '_blank';
                        return `<a href="${item.href}" target="${target}">${label}</a>`;
                    }
                }
                return '';
            },
        },
        watch: {
            loadingError: {
                immediate: false,
                deep: true,
                handler(value, oldVal) {
                    if(value){
                        this.$emit('error', value);
                    }
                },
            },
        }
    }

</script>

<style scoped lang="scss">
    @import "@styles/_theme.scss";
    .panel-form {
        .panel-form-data {
            &.loading {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                > div {
                    overflow: 'hidden';
                    width: 176px;
                    height: 176px;
                }
            }

            input:focus-visible {
                outline: none;
            }


            table {
                width: 100%;
                color: #6e6e6e;
                border-collapse: collapse;
                border-spacing: 0;

                tbody {
                    background-color: #ffffff;
                    font-size: .9rem;

                    tr {
                        border-bottom: solid 1px #dddddd;
                    }

                    td {
                        padding: 3px 4px 3px;

                        &:first-child {
                            text-align: left;
                            font-family: $city-medium-font-family;
                        }

                        &:last-child {
                            font-family: $city-font-family;
                            text-align: right;
                        }
                    }
                }
            }

        }
    }
</style>